var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.750244 6.75C4.35024 -1.25 15.1502 -1.25 18.7502 6.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75024 10.75C9.35628 10.75 8.96617 10.6724 8.60219 10.5216C8.23822 10.3709 7.9075 10.1499 7.62892 9.87132C7.35035 9.59274 7.12937 9.26203 6.97861 8.89805C6.82784 8.53407 6.75024 8.14397 6.75024 7.75C6.75024 7.35603 6.82784 6.96593 6.97861 6.60195C7.12937 6.23797 7.35035 5.90726 7.62892 5.62868C7.9075 5.3501 8.23822 5.12913 8.60219 4.97836C8.96617 4.8276 9.35628 4.75 9.75024 4.75C10.5459 4.75 11.309 5.06607 11.8716 5.62868C12.4342 6.19129 12.7502 6.95435 12.7502 7.75C12.7502 8.54565 12.4342 9.30871 11.8716 9.87132C11.309 10.4339 10.5459 10.75 9.75024 10.75Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.658d80d79ea96a057f6635138ce8bee9.svg";
export { ForwardRef as ReactComponent };